import React from "react";
import TagsChart from "./Charts/TagsChart";
import { useTheme } from "@mui/styles";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";

const TagsView = ({ displaySelection, tagsViewMortgages }) => {
  const theme = useTheme()

  return (
    <TagsViewFrame>
      {tagsViewMortgages === undefined ?
        <TagsViewLoading>
          <CircularProgress
            sx={{ color: `${theme.palette.primary.main}`}}
            size={48}
          />
        </TagsViewLoading>
      : displaySelection === 'Chart View' &&
        <TagsChart tagsViewMortgages={tagsViewMortgages} />
      }
    </TagsViewFrame>
  )
}

const TagsViewFrame = styled("div")({
  width: "100%",
  height: "100%",
  minHeight: 0,
  minWidth: 0,
  display: "grid",
  placeItems: "stretch",
})

const TagsViewLoading = styled("div")({
  display: "grid",
  placeItems: "center",
  minHeight: 0,
})

export default TagsView
